/**
 * Fingerprints for Val plan dirty-checking (Ship/leave guard).
 * Stable JSON of the payload that would be persisted for each layer.
 */

export function fingerprintLayer1(
  result: unknown,
  edits: Record<string, string>,
): string {
  return JSON.stringify({ result, edits })
}

export function fingerprintLayer2(
  scenarios: unknown,
  reviews: Record<string, unknown>,
  complianceGaps: unknown,
): string {
  return JSON.stringify({
    scenarios,
    reviews,
    compliance_gaps: complianceGaps,
  })
}

export function fingerprintLayer3(
  gaps: unknown,
  dispositions: Record<string, unknown>,
): string {
  return JSON.stringify({ gaps, dispositions })
}

/** Work exists and differs from (or has never been) last successful save. */
export function isLayerDirty(
  hasWork: boolean,
  currentFingerprint: string | null,
  savedFingerprint: string | null,
): boolean {
  if (!hasWork) return false
  if (savedFingerprint === null) return true
  if (currentFingerprint === null) return true
  return currentFingerprint !== savedFingerprint
}

export function isPlanDirty(layers: {
  l1: boolean
  l2: boolean
  l3: boolean
}): boolean {
  return layers.l1 || layers.l2 || layers.l3
}
